export default __webpack_public_path__ + "static/media/ChloroLegend.806ef7e4.png";